import apiClient, { normalizeApiError } from "./axiosConfig";
import { isServerError } from "./globalErrorBridge";

const JSON_HEADERS = {
  "Content-Type": "application/json",
};

const request = (options) =>
  apiClient(options)
    .catch((error) => {
      throw normalizeApiError(error);
    })
    .then((response) => {
      const data = response.data;
      const statusCode = data?.statusCode || response.status;

      if (isServerError(statusCode)) {
        throw data;
      }

      return data;
    });

export function fetchCall(url, method, payload, config = {}) {
  return request({
    method,
    url,
    data: payload,
    headers: JSON_HEADERS,
    skipAuth: true,
    skipRefresh: true,
    ...config,
  });
}

export function fetchLoginCall(url, method, payload) {
  return request({
    method,
    url,
    data: payload,
    headers: {
      ...JSON_HEADERS,
      accept: "text/plain",
    },
  });
}

// No Content-Type here - axios sets the multipart boundary itself when
// `data` is a FormData instance.
export function fetchFormDataCall(url, method, formData) {
  return request({
    method,
    url,
    data: formData,
    headers: { accept: "text/plain" },
  });
}
